export default __webpack_public_path__ + "static/media/ActiveTwitter.eafa6da9.svg";